import { ModelsShowcase } from "@/components/sections/models-showcase";
import { Helmet } from "react-helmet-async";

export default function ProductsPage() {
  return (
    <>
      <Helmet>
        <title>長安跨越 V7-EV 車型展示 | 電動七人車規格價格 | 長安跨越</title>
        <meta name="description" content="長安跨越 V7-EV 電動七人車詳細規格：續航280公里、電池53.5kWh、載貨6.7m³。售價 HK$198,000 起。1號牌照可去機場，適合 Uber 滴滴網約車。香港觀塘展示廳歡迎預約試駕。" />
      </Helmet>
      <div className="min-h-screen">
        <ModelsShowcase />
      </div>
    </>
  );
}
